import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "schemeWithCheckmarkShield",
    iconColor: "white",
    text: "Automated data \ningestion pipelines \nbased on English \nlanguage instructions",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "schemeAndBuildingInline",
    iconColor: "white",
    text: "Reduction in cost of data\nintegration",
    listItemCustomStyle: { width: "255px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithCloud",
    iconColor: "white",
    text: "Improvement in data \nengineer productivity",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_DNA2_1 = {
  title: "AI assisted Pipeline Design with \ncodeless automation",
  titleNumber: "1.",
  text: "Synchronizing or transforming data at scale is automated through an AI-\ndriven real-time pipeline and processing, ensuring a focus on outcomes \nrather than code.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage(203),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(201),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_02.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  demoButtons: [
    {
      label: "Data Streams demo",
      onClick: () => {
        setPreviousPage(202);
        setCurrentPage(205);
      },
      endIcon: "play",
    },
  ],
};
